import http from '@/core/http'
import { map } from 'lodash'

const state = {
  itens: []
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get('referencia-comissoes', {params: payload })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  cadastrarItem: async (_, payload) => {
    const result = await http.post('afiliados-comissoes', payload)
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put('afiliados-comissoes', payload)
    return Promise.resolve(result)
  },

  deletarItem: async (_, payload) => {
    const result = await http.delete('afiliados-comissoes', { params: payload })
    return Promise.resolve(result)
  },
  
  getItem: async ({ commit }, payload) => {
    const result = await http.get('afiliados-comissoes', { params: { _addlFilter: { 'ContractsAffiliate:id_=': payload.id }} })
    commit('LISTA_ITEM', result)
    Promise.resolve(result)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },

  clearItens: ({ commit }) => {
    commit('CLEAR_ITENS')
    
  }
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LISTA_ITEM' (state, payload) {
    state.item = payload.data.resultMap[0]
    state.listValues = payload.data.resultMap[0].contractRangeValues || []
  },

  'LIMPAR_ITEM' () {
  },
  'CLEAR_ITENS' (state) {
    state.itens = []
    state.totalItens = 0
  }
}

const getters = {
  listaItens: state => state.itens,
  itensSelect: state => map(state.itens, item => ({ name: item.name, id: item.id }))
}

export default { namespaced: true, state, actions, mutations, getters }